import "core-js/modules/web.timers";

/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import { isIOS, isIE11 } from '../../../lib/device/operating-system'; // Called by the framework to set focus on a specified node
// after a ChildWindow is closed. Contains a workaround to deal
// with VoiceOver’s inability to consistently follow visual focus.
// IE11 also has this inability.

var restoreIOSFocus = function restoreIOSFocus(_ref) {
  var node = _ref.node,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 200 : _ref$delay;
  setTimeout(function () {
    node.focus();

    if (node.tagName.toLowerCase() === 'input') {
      node.select();
    }
  }, delay);
};

var restoreIE11Focus = function restoreIE11Focus(_ref2) {
  var node = _ref2.node,
      _ref2$delay = _ref2.delay,
      delay = _ref2$delay === void 0 ? 550 : _ref2$delay;
  setTimeout(function () {
    node.focus();

    if (node.tagName.toLowerCase() === 'input') {
      node.select();
    }
  }, delay);
};

var restoreFocus = function restoreFocus(_ref3) {
  var node = _ref3.node,
      _ref3$delay = _ref3.delay,
      delay = _ref3$delay === void 0 ? 0 : _ref3$delay;
  setTimeout(function () {
    node.focus();

    if (node.tagName.toLowerCase() === 'input') {
      node.select();
    }
  }, delay);
};

export default (function (_ref4) {
  var node = _ref4.node,
      delay = _ref4.delay;
  window._lastElementClicked = null;

  if (isIOS()) {
    return restoreIOSFocus({
      node: node,
      delay: delay
    });
  } else if (isIE11()) {
    return restoreIE11Focus({
      node: node,
      delay: delay
    });
  } else {
    return restoreFocus({
      node: node,
      delay: delay
    });
  }
});